import { type ReactNode } from "react";
import clsx from "clsx";
import { SuccessIcon } from "@/shared/assets/svg/icons";
import type { components } from "@entities/journal";

type Signer = components["schemas"]["SignerInfo"];

export const SuccessSign = ({
  children,
  signer,
  mchdId,
}: {
  children: ReactNode;
  signer: Signer | undefined;
  mchdId?: string;
}) => {
  return (
    <div className="table-block">
      <div
        className={clsx("table-container table-container-signature", {
          [`table-container-signature-success`]: "success",
        })}
      >
        {children}
        <div className="represented-container success">
          <div className="flex-between represented-status-row">
            <div className="flex-default">
              <div className="represented-icon-container success">
                <SuccessIcon />
              </div>
              Подписано
            </div>
            <div>
              {signer?.updateDate
                ? new Date(signer.updateDate).toLocaleString("ru-RU", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                  })
                : ""}
            </div>
          </div>
          {mchdId ? (
            <div className="represented-mchd">
              Доверенность № {mchdId}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};
